import React from "react";
import { Typography, Box } from "@mui/material";
import { FontSize, useThemeStore } from "../../stores/ThemeStore";

type Props = {
    labelStrong?: string | null;
    labelSmall?: string | null;
    value?: string;
    isHeader?: boolean;
};

const captionFontSizeMapping = {
    [FontSize.Small]: 16,
    [FontSize.Big]: 20,
  };

  const titleFontSizeMapping = {
    [FontSize.Small]: 20,
    [FontSize.Big]: 24,
  };

const RsDataField = ({
    labelStrong,
    labelSmall,
    value,
    isHeader = false
}: Props) => {
    const {currentFontSize} = useThemeStore()
    // Display a dash if value is falsy or an empty string
    const displayValue = value || "-";

    return (
        <Box display="flex"
            flexDirection="column"
            height="100%"
        >
            {(labelStrong || labelSmall) && (
                <Typography color="textSecondary" variant="caption" gutterBottom sx={{fontSize: captionFontSizeMapping[currentFontSize]}}>
                    {labelStrong && <strong>{labelStrong}</strong>}
                    {labelSmall && ` ${labelSmall}`}
                </Typography>
            )}
            {!isHeader && (
                <Typography color="textPrimary" variant="h6" ml={{ xs: 0, sm: 1 }} sx={{fontSize: titleFontSizeMapping[currentFontSize]}}>
                    {displayValue}
                </Typography>
            )}
        </Box >
    );
};

export default RsDataField;
